/* Undo depth for the universal undo timeline (editor-chrome/undoCoordinator.ts),
 * whichever history the editor runs: ProseMirror's History on an unshared
 * canvas, the Yjs undo manager on a live shared draft (Collaboration swaps
 * History out — its plugin state is absent, so `undoDepth` alone reads 0). */
import { undoDepth } from '@tiptap/pm/history';
import type { EditorState } from '@tiptap/pm/state';
import { yUndoPluginKey } from 'y-prosemirror';

interface YUndoState {
  undoManager?: { undoStack: readonly unknown[] };
}

export function docUndoDepth(state: EditorState): number {
  const y = yUndoPluginKey.getState(state) as YUndoState | undefined;
  if (y?.undoManager) return y.undoManager.undoStack.length;
  return undoDepth(state);
}
